import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAppStore } from './store'
import { api } from './lib/api'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'
import { VaultPage } from './pages/VaultPage'
import { SettingsPage } from './pages/SettingsPage'
import { AddVaultPage } from './pages/AddVaultPage'
import { CreateVaultPage } from './pages/CreateVaultPage'

export default function App() {
  const setUserEmail = useAppStore((s) => s.setUserEmail)
  const setBookmarkedVaultIds = useAppStore((s) => s.setBookmarkedVaultIds)

  // The redesign is dark-only.
  useEffect(() => {
    document.documentElement.classList.add('dark')
  }, [])

  // Fetch user info and bookmarks on mount
  useEffect(() => {
    async function init() {
      try {
        const user = await api.getCurrentUser()
        setUserEmail(user.email)

        const bookmarks = await api.getBookmarks()
        setBookmarkedVaultIds(bookmarks)
      } catch (error) {
        console.error('Failed to initialize:', error)
      }
    }
    init()
  }, [setUserEmail, setBookmarkedVaultIds])

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="add" element={<AddVaultPage />} />
        <Route path="create" element={<CreateVaultPage />} />
        <Route path="v/:vaultId" element={<VaultPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
